import { ArrowSquareOut } from '@phosphor-icons/react';
import { dokumentOeffnenUrl } from '../../../../lib/dokumente/dokumentLink';
import { deDatum } from '../../../../lib/immobilien/objektDetail';
import type { DokumentZeile } from '../../../../lib/immobilien/useObjektDetail';

/** Dokument als Kachel; Klick öffnet die Datei (OneDrive/Drive/Speicher) in einem neuen Tab. */
export function DokumentKachel({ d, zusatz }: { d: DokumentZeile; zusatz?: string }) {
  const url = dokumentOeffnenUrl(d);
  const endung = (d.datei_name?.includes('.') ? d.datei_name.split('.').pop() : (d.datei_typ ?? '').split('/').pop()) || 'DOK';
  return (
    <button type="button" disabled={!url} onClick={url ? () => window.open(url, '_blank', 'noopener,noreferrer') : undefined}
      title={url ? 'Datei öffnen' : 'Nur im Dokumentenbereich erreichbar'}
      className={`immo-innen flex items-center text-left ${url ? 'immo-hover-flaeche cursor-pointer' : 'cursor-default'}`}
      style={{ borderRadius: 18, padding: 12, gap: 12, border: 'none', color: 'var(--ink)', opacity: url ? 1 : 0.6 }}>
      <span className="flex items-end justify-center shrink-0" style={{ width: 36, height: 44, borderRadius: 8, paddingBottom: 5, background: 'linear-gradient(180deg,#f4f4f6,#d9d9de)', boxShadow: '0 4px 10px var(--shade)' }}>
        <span style={{ fontSize: 8, fontWeight: 800, color: 'var(--bad)' }}>{endung.slice(0, 4).toUpperCase()}</span>
      </span>
      <span className="flex flex-col flex-1 min-w-0" style={{ gap: 2 }}>
        <span className="truncate" style={{ fontSize: 14, fontWeight: 700 }}>{d.titel || d.datei_name || 'Dokument'}</span>
        <span className="truncate" style={{ fontSize: 11, color: 'var(--ink3)' }}>{[zusatz, deDatum(d.created_at)].filter(Boolean).join(' · ')}</span>
      </span>
      {url && <ArrowSquareOut size={15} color="var(--ink3)" />}
    </button>
  );
}

export function DokumentRaster({ children }: { children: React.ReactNode }) {
  return <div className="grid" style={{ gridTemplateColumns: 'repeat(auto-fill,minmax(min(250px,100%),1fr))', gap: 8 }}>{children}</div>;
}
